import _ from "lodash";
import {
  Component,
} from "react";

/*
 * import {
 *   Button,
 * } from "react-bootstrap";
 */
import {
  Link,
} from "react-router-dom";
import {
  withLocation,
} from "CommonCore/router-util";
import moment from "moment";

import store from "CommonState/store";
import Breadcrumb from "CommonComponents/breadcrumb";

import massnahmeApi from "Apis/massnahme-api";

import EntityTable from "CommonComponents/entity-table";
import {
  IsoDateFormat,
} from "CommonCore/l10n";
import {
  injectsFromSchemaAndRenderMethods, createInjectsSelector,
} from "CommonCore/schema-util";
// import Confirmation from "CommonComponents/confirmation";
import {
  ANTRAGSTATUS, ROLLEN, ROLLEN_SACHB, config,
} from "App/constants";

const TableRenderMethods = {
  m_bez: (item, obj) => obj && <Link to={"/massnahme/" + obj.m_id}>{item}</Link>,
  antrag: {
    inject: ["user"],
    // PBP-1066: Dekan darf keinen Link auf Anträge im Status Neu sehen
    generator: user => (item, obj) => item && obj && ([ROLLEN.ROLLE_DEKANAT, ...ROLLEN_SACHB].indexOf(user.ro_id) >= 0 && item.a_asid == ANTRAGSTATUS.STATUS_NEU ? item.a_nr : <Link to={"/antrag/" + item.a_id}>{item.a_nr}</Link>),
  },
  m_staort: array => <ul style={{ paddingInlineStart: "20px" }}>{_.map(array, a => <li>{a}</li>)}</ul>,

};

const injects = injectsFromSchemaAndRenderMethods(massnahmeApi.schema, TableRenderMethods);
const selectInjects = createInjectsSelector(injects);

@withLocation
@store(...injects, "massnahmetyp", "currentMassnahmeInflight", "user")
@massnahmeApi.uiList
@massnahmeApi.noCache
export default class MnListPage extends Component {
  constructor() {
    super();
    this.state = {
      edits: {},
      roleType: undefined,
    };
  }

  render() {
    const {
      uiMassnahmeList,
      route,
    } = this.props;

    return <div>
      <Breadcrumb name='Maßnahmenplanung' route={route} />
      <EntityTable
        list='massnahmeList'
        data={uiMassnahmeList}
        schema={massnahmeApi.schema}
        renderMethods={TableRenderMethods}
        injects={selectInjects(this.props)}
        actions={() => {
          const a = [
            {
              display: "Anzeigen",
              icon: "eye",
              execute: m => `/massnahme/${ m.m_id }`,
            },
          ];
          return a;
        }}
      />
    </div>;
  }

  createMassnahme = async() => {
    const {
      history,
      saveMassnahme,
    } = this.props;

    const data = {
      m_bez: "Neue Maßnahme",
      m_gueltigab: moment.utc().add(config.getValue("EINSTELLUNG_PUFFER_WOCHEN_DEFAULT"), "week").add(2, "day").format(IsoDateFormat),
    };
    let newMassnahme;
    try {
      newMassnahme = await saveMassnahme(data);
    } catch(e) {
      const response = e.response || { nachricht: "Es ist ein Fehler aufgetreten." };
      this.setState({
        validationMessage: response.nachricht || response.um,
        validationErrors: response.details,
      });
      return;
    }

    history.push("massnahme/" + newMassnahme.m_id);
  };
}

/*
 * @massnahmeApi.actions
 * @store("currentMassnahmeInflight")
 * class MassnahmeLoeschen extends Component {
 *   constructor() {
 *     super();
 *     this.state = {};
 *   }
 *
 *   render() {
 *     const { item, onClose, currentMassnahmeInflight: inflight } = this.props;
 *     const { deleteFailedMessage } = this.state;
 *
 *     return (
 *       <Confirmation
 *         header='Massnahme löschen'
 *         body={`Sind Sie sicher, dass Sie die Maßnahme ${ item.m_bez } unwiderruflich löschen möchten?`}
 *         action='Löschen'
 *         inflight={inflight}
 *         onCancel={onClose}
 *         onConfirm={this.onConfirm}
 *         errorMessage={deleteFailedMessage}
 *       />
 *     );
 *   }
 *
 *   onConfirm = async() => {
 *     const { item, deleteMassnahme } = this.props;
 *     try {
 *       await deleteMassnahme(item.m_id);
 *       this.props.onClose();
 *     } catch (err) {
 *       this.setState({
 *         deleteFailedMessage:
 *           (err.response && (err.response.nachricht || err.response.um))
 *           || "Es ist ein Fehler aufgetreten.",
 *       });
 *     }
 *   };
 * }
 *
 * @withLocation
 * export class GoToButton extends React.Component {
 *   render() {
 *     const {
 *       name,
 *     } = this.props;
 *     return <Button variant='outline-primary' onClick={this.navigate}>
 *       {name}
 *     </Button>;
 *   }
 *   navigate = () => {
 *     const { history, to } = this.props;
 *     history.push(to);
 *   };
 * }
 */
